import React, { Fragment } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoute from "./route/AppRoute";
import GoToTop from "./components/common/GoToTop";

function App() {
  return (
    <Fragment>
      <BrowserRouter>
        <GoToTop />
        <AppRoute />
      </BrowserRouter>
    </Fragment>
  );
}

export default App;
